import { AuditType, OrderAuditLogData, PaymentLinkAuditLogData, VoucherAuditLogData } from '../api';
import { EventAuditLogData } from '../api/models/EventAuditLogData';

export type AuditLogData = OrderAuditLogData | EventAuditLogData | VoucherAuditLogData | PaymentLinkAuditLogData;

export interface AuditLogFilters {
  auditTypes?: AuditType[];
  orderNumber?: number;
  startDate?: string;
  endDate?: string;
  page?: number;
  perPage?: number;
}

export interface AuditLogTableProps {
  filters?: AuditLogFilters;
  hideActions?: boolean;
}

export type AuditLogWithType<T extends AuditType> = T extends
  | AuditType.ORDER_CREATED
  | AuditType.ORDER_UPDATED
  | AuditType.ORDER_DELETED
  ? OrderAuditLogData
  : T extends AuditType.EVENT_CREATED | AuditType.EVENT_UPDATED | AuditType.EVENT_DELETED
  ? EventAuditLogData
  : T extends
      | AuditType.ORDER_CONVERTED_TO_VOUCHER
      | AuditType.VOUCHER_CREATED_FROM_ORDER
      | AuditType.VOUCHER_CONVERTED_TO_ORDER
      | AuditType.ORDER_CREATED_FROM_VOUCHER
  ? VoucherAuditLogData
  : T extends AuditType.PAYMENT_LINK_CREATED | AuditType.PAYMENT_LINK_PAID
  ? PaymentLinkAuditLogData
  : AuditLogData;

export const isOrderAuditLog = (log: AuditLogData): log is OrderAuditLogData => {
  return [AuditType.ORDER_CREATED, AuditType.ORDER_UPDATED, AuditType.ORDER_DELETED].includes(log.audit_type);
};

export const isEventAuditLog = (log: AuditLogData): log is EventAuditLogData => {
  return [AuditType.EVENT_CREATED, AuditType.EVENT_UPDATED, AuditType.EVENT_DELETED].includes(log.audit_type);
};

export const isVoucherAuditLog = (log: AuditLogData): log is VoucherAuditLogData => {
  return [
    AuditType.ORDER_CONVERTED_TO_VOUCHER,
    AuditType.VOUCHER_CREATED_FROM_ORDER,
    AuditType.VOUCHER_CONVERTED_TO_ORDER,
    AuditType.ORDER_CREATED_FROM_VOUCHER,
  ].includes(log.audit_type);
};

export const isPaymentLinkAuditLog = (log: AuditLogData): log is PaymentLinkAuditLogData => {
  return [AuditType.PAYMENT_LINK_CREATED, AuditType.PAYMENT_LINK_PAID].includes(log.audit_type);
};
